<template>
  <a
    :href="url"
    class="flex p-4 border border-b-2 rounded-lg hover:border-primary-100 hover:ring-4 ring-primary-100 dark:hover:ring-gray-500 dark:hover:ring-2 dark:hover:border-none"
  >
    <div class="flex flex-col py-1">
      <p class="text-lg leading-none font-display">{{ title }}</p>
      <p v-if="desc" class="text-sm text-gray-500">{{ desc }}</p>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    desc: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
  },
};
</script>
